export const AUTOMATION_BASE = 'automationplatform';
export const AUTOMATION_ENROLLMENT_BASE = 'automation-enrollment';
export const AUTOMATION_BULK_PROCESSING_BASE = 'automation-platform-bulk-processing';

// Access
export const FLOW_ACCESS = `${AUTOMATION_BASE}/v1/access`;

// Bulk_Processing
export const BULK_PROCESSING = `${AUTOMATION_BULK_PROCESSING_BASE}/v1/bulk-processing`;

// Current_Enrollments
export const ACTIVE_OBJECTS = `${AUTOMATION_ENROLLMENT_BASE}/v1/current-enrollments/flow`;

// Enrollments
export const BULK_ENROLLMENTS = `${AUTOMATION_ENROLLMENT_BASE}/v1/enrollments/flow/batch/enroll`;
export const UNENROLLMENT = `${AUTOMATION_ENROLLMENT_BASE}/v1/enrollments`;

// Flows
export const FLOWS = `${AUTOMATION_BASE}/v1/flows`;
export const FLOWS_UUID = `${AUTOMATION_BASE}/v1/flows/uuid`;
export const FLOWS_BATCH_UPDATE = `${AUTOMATION_BASE}/v1/flows/batch`;

// History
// moved to automation-ui-log-events/api-client/api/PlatformApiRoutes.js

// Hybrid
export const HYBRID_FLOWS = `${AUTOMATION_BASE}/v1/hybrid`;
export const HYBRID_FLOWS_UUID = `${AUTOMATION_BASE}/v1/hybrid/uuid`;
export const HYBRID_FLOWS_UUIDS = `${AUTOMATION_BASE}/v1/hybrid/uuids/fetch`;
export const HYBRID_FLOWS_BATCH_UPDATE = `${AUTOMATION_BASE}/v1/hybrid/batch`;
export const HYBRID_FLOWS_BATCH_DELETE = `${AUTOMATION_BASE}/v1/hybrid/batch-delete`;
export const HYBRID_FLOW_REVISIONS = `${AUTOMATION_BASE}/v1/hybrid/revisions`;

// Migration
export const MIGRATION_STATUS = `${AUTOMATION_BASE}/v1/migration/workflow`;

// Revisions
export const FLOW_REVISIONS_FOR_CLONING = `${AUTOMATION_BASE}/v1/revisions`; // TODO: unused

// Simulate_Flow
export const FLOWS_SIMULATE_DYNAMIC_LOGS = `automationapps/v1/history/simulate`;

// Validation
export const VALIDATION = `${AUTOMATION_BASE}/v1/validation`;